module.exports = "<div ng-if=\"ctrl.isCancelledOrder\" class=\"row ut-receipt-cancelledAlert\">\n    <div class = \"col-12 mt-3 text-center\">\n        <div class=\"p-1 h4 mb-0 notification_bar notification_bar_top_text cancelled-header_title\">\n            ORDER CANCELLATION\n        </div>\n        <div class=\"p-1 h5 mb-0 notification_bar notification_bar_bottom_text border-top-0\">\n            Cancelled {{ctrl.updatedAt}}\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/cancelledBar.html
// module id = 757
// module chunks = 0